import React, {useEffect, useState} from "react"
import axios from "axios";
import {ArsDocumentsType} from "../../../Shared/Enums/ArsDocumentsType";
import {downloadPDFFolders, generatePdfIframe} from "../../../Shared/PDF/PDFManager";
import Loader from "../../Controle/Loader";
import {toast} from "react-toastify";
import Helper from "../../../Shared/Helper";
import Tooltip from "../../../Shared/Tootip"


const sortAndFormatDocuments = (document_list) => {
    let temp_document_list = document_list.map((document) => {
        let temp_document = {...document}
        temp_document.iframe = null
        return temp_document
    })
    return temp_document_list.sort((document_a, document_b) => {
        let a_full_signed = document_a.user_signatures.every((signature) => signature.date !== null)
        let b_full_signed = document_b.user_signatures.every((signature) => signature.date !== null)

        if (a_full_signed === b_full_signed) return 0
        if (a_full_signed && !b_full_signed) return 1
        return -1
    })
}


export default function OrthoptistDocuments(props) {

    const [collapsible_instances, setCollapsibleInstances] = useState([])
    const [documents, setDocuments] = useState(sortAndFormatDocuments(props.orthoptist.documents))

    const signDocument = (document_id) => {
        axios.patch(`/signDocument/${document_id}`)
            .then((_) => {
                let modified_document
                let temp_documents = documents.map((document) => {
                    if (document.id === document_id) {
                        let signature_index = document.user_signatures.findIndex(
                            (signature) => signature.user_id === props.ophtalmologist.user_id)
                        document.user_signatures[signature_index].date = new Date()
                        modified_document = document
                    }
                    return document
                })
                handlePdf(modified_document, true)
                setDocuments(temp_documents)
                toast.success("Votre document est désormais signé.")
            })
            .catch((error) => toast.error("Erreur lors de la signature") && console.log(error))

    }

    const signAllDocuments = () => {
        let documents_to_sign = documents.map((document) => {
            if (!getOphtalmologistSignature(document).date) return document.id
        }).filter(Boolean)

        if (!documents_to_sign.length) return

        axios.patch(`/signDocuments/`, {documents_to_sign: documents_to_sign})
            .then((resp) => {
                let temp_documents = [...documents]
                let modified_document
                temp_documents.map((document) => {
                    if (documents_to_sign.includes(document.id) && !resp.data.failed.includes(document.id)) {
                        let signature_index = document.user_signatures.findIndex(
                            (signature) => signature.user_id === props.ophtalmologist.user_id)
                        document.user_signatures[signature_index].date = new Date()
                        modified_document = document
                    }
                    if (modified_document) handlePdf(modified_document, true)
                    return document
                })
                toast.success("Signatures enregistrées.")
            })
            .catch((_) => toast.error("Erreur lors des signatures"))
    }

    useEffect(() => {
        let elements = document.querySelectorAll("[id=arsDocumentDropdown]")
        setCollapsibleInstances(M.Collapsible.init(elements, {}))
        return () => collapsible_instances.map((instance) => instance.destroy())
    }, [])

    const handlePdf = async (modified_document, ignore_existing_iframe = false) => {

        if (modified_document.iframe && !ignore_existing_iframe) return

        let pdf_data = getPdfData(modified_document)
        let document_uri = ArsDocumentsType[modified_document.document_type].url
        let document_title = ArsDocumentsType[modified_document.document_type].title

        await generatePdfIframe(document_uri, document_title, pdf_data)
            .then((iframe_doc) => {
                    let modified_array = documents.map((document) => {
                        if (document.id === modified_document.id) {
                            return {...document, iframe: iframe_doc}
                        }
                        return document
                    })
                    setDocuments(modified_array)
                }
            )
            .catch((error) => console.log(error))
    }

    const formatAndDownloadDocuments = () => {
        const zip_data = documents.map((document) => {
            return {
                type: "file",
                name: `${Helper.formatName(props.orthoptist.first_name, props.orthoptist.last_name)} ${ArsDocumentsType[document.document_type].title}.pdf`,
                uri: ArsDocumentsType[document.document_type].url,
                content: getPdfData(document)
            }
        })
        downloadPDFFolders(Helper.formatName(props.orthoptist.first_name, props.orthoptist.last_name), zip_data)
    }

    const getSignatureDate = (document_signatures) => {
        let signature_count = document_signatures.map((signature) => signature.date !== null).filter(Boolean).length
        let ophtalmologist_signature = document_signatures.find((signature) => signature.user_id === props.ophtalmologist.user_id)

        let signature_date
        if (signature_count === document_signatures.length) {
            signature_date = document_signatures.reduce((a, b) => {
                return new Date(a.date) > new Date(b.date) ? a : b;
            })
            signature_date = signature_date.date
        }
        if ((document_signatures.length - signature_count === 1) && ophtalmologist_signature.date === null) {
            signature_date = new Date()
        }
        return signature_date
    }

    const getOphtalmologistSignature = (document) => {
        return document.user_signatures.find((signature) => signature.user_id === props.ophtalmologist.user_id)
    }

    const getOrthoptistSignature = (document) => {
        return document.user_signatures.find((signature) => signature.user_id === props.orthoptist.user_id)
    }

    const getPdfData = (document) => {
        let signature_ophtalmologist = Helper.toCamelCase(`${props.ophtalmologist.first_name} ${props.ophtalmologist.last_name}`) ?? ""
        let signature_orthoptist = Helper.formatName(`${props.orthoptist.first_name} ${props.orthoptist.last_name}`) ?? ""
        let signature_date = getSignatureDate(document.user_signatures)

        switch (document.document_type) {
            case ArsDocumentsType.EMPLOYER_ACCORD_6_15.document_type:
            case ArsDocumentsType.EMPLOYER_ACCORD_16_50.document_type:
            case ArsDocumentsType.EMPLOYER_ACCORD_RETINO.document_type:
                return {
                    nom_employeur: Helper.toCamelCase(props.office.director_fullname) ?? "",
                    nom_ophtalmologiste1: Helper.formatName(props.ophtalmologist.first_name, props.ophtalmologist.last_name) ?? "",
                    ville_employeur: props.office.city ?? "",
                    nom_structure: props.office.name ?? "",
                    nom_orthoptiste1: Helper.formatName(props.orthoptist.first_name, props.orthoptist.last_name) ?? "",
                    date: signature_date ? Helper.formatDate(signature_date) : "",
                    signature_employeur: Helper.toCamelCase(props.office.director_fullname) ?? ""
                }

            case ArsDocumentsType.ENGAGEMENT_ACCORD_6_15.document_type:
            case ArsDocumentsType.ENGAGEMENT_ACCORD_16_50.document_type:
            case ArsDocumentsType.ENGAGEMENT_ACCORD_RETINO.document_type:
                return {
                    nom_ophtalmo1: Helper.capitalizeFirstLetter(props.ophtalmologist.last_name) ?? "",
                    prenom_ophtalmo1: Helper.capitalizeFirstLetter(props.ophtalmologist.first_name) ?? "",
                    profession_delegant: "Ophtalmologiste",
                    profession_delegue: "Orthoptiste",
                    ville_ophtalmo: props.office_location.current ?? "",
                    rpps_ophtalmo1: props.ophtalmologist.rpps ?? "",
                    adeli_ortho1: props.orthoptist.adeli ?? "",
                    prenom_ortho1: Helper.capitalizeFirstLetter(props.orthoptist.first_name) ?? "",
                    nom_ortho1: Helper.capitalizeFirstLetter(props.orthoptist.last_name) ?? "",
                    date: signature_date ? Helper.formatDate(signature_date) : "",
                    signature_ophtalmo1: signature_ophtalmologist,
                    signature_ortho1: signature_orthoptist
                }

            case ArsDocumentsType.PREREQUISITE_VALIDATION_6_15.document_type:
            case ArsDocumentsType.PREREQUISITE_VALIDATION_16_50.document_type:
            case ArsDocumentsType.PREREQUISITE_VALIDATION_RETINO.document_type:
                return {
                    nom_ophtalmologiste1: Helper.formatName(props.ophtalmologist.first_name, props.ophtalmologist.last_name) ?? "",
                    nom_ophtalmologiste1b: Helper.formatName(props.ophtalmologist.first_name, props.ophtalmologist.last_name) ?? "",
                    nom_orthoptiste1: Helper.formatName(props.orthoptist.first_name, props.orthoptist.last_name) ?? "",
                    ville_ophtalmo: props.office_location.current ?? "",
                    date: signature_date ? Helper.formatDate(signature_date) : "",
                    signature_ophtalmo1: signature_ophtalmologist
                }

            case ArsDocumentsType.ACQUISITION_ATTESTATION_RETINO.document_type:
                return {
                    nom_ophtalmologiste1: Helper.formatName(props.ophtalmologist.first_name, props.ophtalmologist.last_name) ?? "",
                    ville_ophta: props.office_location.current ?? "",
                    date_ophta: signature_date ? Helper.formatDate(signature_date) : "",
                    signature_ophta: signature_ophtalmologist,
                    nom_orthoptiste1: Helper.formatName(props.orthoptist.first_name, props.orthoptist.last_name) ?? "",
                    nom_ophtalmologiste1b: Helper.formatName(props.ophtalmologist.first_name, props.ophtalmologist.last_name) ?? "",
                    ville_ortho: props.office_location.current ?? "",
                    date_ortho: signature_date ? Helper.formatDate(signature_date) : "",
                    signature_ortho: signature_orthoptist
                }

            default:
                return
        }
    }

    const isDocumentSigned = (document) => {
        let ophtalmologist_signature = getOphtalmologistSignature(document)
        let orthoptist_signature = getOrthoptistSignature(document)
        if ((orthoptist_signature && orthoptist_signature.date)
            && ophtalmologist_signature && ophtalmologist_signature.date) {
            return <i className="material-icons green-text">check_circle</i>
        }
        if (!(orthoptist_signature && orthoptist_signature.date)
            && ophtalmologist_signature && ophtalmologist_signature.date) {
            return <i className="material-icons">hourglass_empty</i>
        } else {
            return <i className="material-icons red-text">cancel</i>
        }
    }

    const areAllDocumentsSigned = () => {
        if(!documents.length) return false
        return documents.every((document) => document.user_signatures.every((signature) => signature.date !== null))
    }

    const areAllDocumentsSignedByUser = () => {
        return documents.every((document) => getOphtalmologistSignature(document).date !== null)
    }

    const areAllDocumentsSignable = () => {
        return documents.every((document) => !getMissingElements(document.document_type).length)
    }

    const getMissingElements = (document_type) => {
        let missing_infos = []
        switch (document_type) {
            case ArsDocumentsType.PREREQUISITE_VALIDATION_6_15.document_type:
            case ArsDocumentsType.PREREQUISITE_VALIDATION_16_50.document_type:
            case ArsDocumentsType.PREREQUISITE_VALIDATION_RETINO.document_type:
                if (!props.ophtalmologist.last_name) missing_infos.push("Votre nom de famille")
                if (!props.ophtalmologist.first_name) missing_infos.push("Votre prénom")
                if (!props.orthoptist.last_name?.length) missing_infos.push("Le nom de famille de l'orthoptiste")
                if (!props.orthoptist.first_name?.length) missing_infos.push("Le prénom de l'orthoptiste")
                if (!props.office_location.current) missing_infos.push("L'adresse du cabinet")
                break
            case ArsDocumentsType.ENGAGEMENT_ACCORD_6_15.document_type:
            case ArsDocumentsType.ENGAGEMENT_ACCORD_16_50.document_type:
            case ArsDocumentsType.ENGAGEMENT_ACCORD_RETINO.document_type:
                if (!props.ophtalmologist.last_name) missing_infos.push("Votre nom de famille")
                if (!props.ophtalmologist.first_name) missing_infos.push("Votre prénom")
                if (!props.orthoptist.last_name) missing_infos.push("Le nom de famille de l'orthoptiste")
                if (!props.orthoptist.first_name) missing_infos.push("Le prénom de l'orthoptiste")
                if (!props.orthoptist.adeli) missing_infos.push("Le numéro Adeli de l'orthoptiste")
                if (!props.office_location.current) missing_infos.push("L'adresse du cabinet")
                if (!props.ophtalmologist.rpps) missing_infos.push("Votre numéro RPPS")
                break
            case ArsDocumentsType.EMPLOYER_ACCORD_6_15.document_type:
            case ArsDocumentsType.EMPLOYER_ACCORD_16_50.document_type:
            case ArsDocumentsType.EMPLOYER_ACCORD_RETINO.document_type:
                if (!props.ophtalmologist.last_name) missing_infos.push("Votre nom de famille")
                if (!props.ophtalmologist.first_name) missing_infos.push("Votre prénom")
                if (!props.office.director_fullname?.length) missing_infos.push("Le nom du directeur du cabinet")
                if (!props.orthoptist.last_name) missing_infos.push("Le nom de famille de l'orthoptiste")
                if (!props.orthoptist.first_name) missing_infos.push("Le prénom de l'orthoptiste")
                if (!props.office.name) missing_infos.push("Le titre du cabinet")
            default:
                break
        }
        return missing_infos
    }

    const getAllMissingElements = () => {
        let missing_infos = []
        if (!props.ophtalmologist.last_name) missing_infos.push("Votre nom de famille")
        if (!props.ophtalmologist.first_name) missing_infos.push("Votre prénom")
        if (!props.orthoptist.last_name?.length) missing_infos.push("Le nom de famille de l'orthoptiste")
        if (!props.orthoptist.first_name?.length) missing_infos.push("Le prénom de l'orthoptiste")
        if (!props.office_location.current) missing_infos.push("L'adresse du cabinet")
        if (!props.ophtalmologist.rpps) missing_infos.push("Votre numéro RPPS")
        if (!props.orthoptist.adeli) missing_infos.push("Le numéro Adeli de l'orthoptiste")
        if (!props.office.director_fullname?.length) missing_infos.push("Le nom du directeur du cabinet")
        if (!props.office.name) missing_infos.push("Le titre du cabinet")

        return missing_infos
    }

    const getAllMissingElementsText = () => {
        const missingElements = getAllMissingElements()
        let text = "Les éléments manquants sont:"
        text = missingElements.reduce((acc, missingElement) => acc + `\n - ${missingElement}`, text)
        return text
    }

    const renderOphtalmologistSignatureInfos = (document) => {
        let ophtalmologist_signature = getOphtalmologistSignature(document)
        if (ophtalmologist_signature.date !== null) {
            return <div style={{display: "flex", alignItems: "center"}}>
                <i className="material-icons-outlined green-text" style={{marginRight: 10}}>check_circle</i>
                <div>
                    Votre signature:<br/>
                    Signé le {Helper.formatDate(ophtalmologist_signature.date)}
                </div>
            </div>
        }
        return <div style={{display: "flex", alignItems: "center"}}>
            <i className="material-icons-outlined red-text" style={{marginRight: 10}}>cancel</i>
            <div>
                Votre signature:<br/>
                En attente de votre signature.
            </div>
        </div>
    }

    const renderOrthoptistSignatureInfos = (document) => {
        let orthoptist_signature = getOrthoptistSignature(document)
        let ophtalmologist_signature = getOphtalmologistSignature(document)

        if (orthoptist_signature && orthoptist_signature.date !== null) {
            return <div style={{display: "flex", alignItems: "center"}}>
                <i className="material-icons-outlined green-text" style={{marginRight: 10}}>check_circle</i>
                <div>
                    Signature de l'orthoptiste:<br/>
                    Signé le {Helper.formatDate(orthoptist_signature.date)}
                </div>
            </div>
        }
        if ((orthoptist_signature && orthoptist_signature.date !== null)
            && (ophtalmologist_signature && ophtalmologist_signature.date !== null)) {
            return <div style={{display: "flex", alignItems: "center"}}>
                <i className="material-icons-outlined red-text" style={{marginRight: 10}}>cancel</i>
                <div>
                    Signature de l'orthoptiste:<br/>
                    En attente de la signature.
                </div>
            </div>
        }
        return <div style={{display: "flex", alignItems: "center"}}>
            <i className="material-icons-outlined" style={{marginRight: 10}}>hourglass_empty</i>
            <div>
                Signature de l'orthoptiste:<br/>
                En attente de la signature.
            </div>
        </div>
    }

    const renderSignatureButton = (document) => {
        let signature_ophtalmologist = getOphtalmologistSignature(document)
        if (signature_ophtalmologist && signature_ophtalmologist.date) {
            return <a className="btn blue darken-2 z-depth-0 disabled"
                      style={{display: "flex", alignItems: "center", width: "fit-content", alignSelf: "center"}}>
                <i className="material-icons-outlined" style={{marginRight: 5}}>check_circle</i>
                <div>Déjà signé</div>
            </a>
        }
        let missing_data = getMissingElements(document.document_type)
        if (missing_data.length) {
            return <div style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                marginTop: 10,
                marginLeft: 20
            }}>
                Des informations sont manquantes avant de permettre la signature:
                {missing_data.map((element, index) => <div key={index}>- {element}<br/></div>)}
            </div>
        }
        return <a className="btn blue darken-2 z-depth-0"
                  onClick={() => signDocument(document.id)}
                  style={{
                      display: "flex",
                      alignItems: "center",
                      width: "fit-content",
                      alignSelf: "center",
                      marginTop: 10
                  }}>
            <i className="material-icons" style={{marginRight: 5}}>edit_note</i>
            <div>Signer le document</div>
        </a>
    }

    const renderSignAllButton = () => {
        if (areAllDocumentsSigned() || areAllDocumentsSignedByUser()) return <a
            className="btn-small blue darken-2 disabled"
            style={{marginLeft: 10}}>
            <i className="material-icons">done</i>
        </a>

        if (!areAllDocumentsSignable()) {
            return <Tooltip
                id={`missing_elements_${props.orthoptist.id}`}
                text={getAllMissingElementsText()}>
                <div style={{width: "fit-content", height: "fit-content",marginLeft: 10}}>
                    <a className="btn-small blue darken-2 disabled">
                        <i className="material-icons">edit_note</i>
                    </a>
                </div>
            </Tooltip>
        }
        return <a className="btn-small blue darken-2"
                  onClick={() => signAllDocuments()}
                  style={{marginLeft: 10}}>
            <i className="material-icons">edit_note</i>
        </a>
    }

    const renderIframe = (iframe) => {
        if (iframe) {
            return <div style={{height: "500px", marginTop: 20, marginBottom: 20}}>
                {iframe}
            </div>
        }
        return <div className="center"><Loader wide text="Chargement du document..."/></div>
    }

    return <div key={`${props.office_id}_${props.orthoptist.id}`}>
        <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
            <div className="center"
                 style={{
                     marginBottom: 5,
                     fontSize: 15
                 }}>
                {Helper.formatName(props.orthoptist.first_name, props.orthoptist.last_name)}
            </div>
            <div style={{display: "flex"}}>
                {renderSignAllButton()}
                <a className={`btn-small blue darken-2 ${areAllDocumentsSigned() ? "" : "disabled"}`}
                   onClick={formatAndDownloadDocuments}>
                    <i className="material-icons">file_download</i>
                </a>
            </div>

        </div>
        <ul className="collapsible" id="arsDocumentDropdown">
            {documents.map((document) => {
                return (
                    <li key={`${props.office.office_id}_${props.orthoptist.id}_${document.id}`}>
                        <div className="collapsible-header"
                             onClick={() => handlePdf(document)}>
                            {isDocumentSigned(document)}
                            {ArsDocumentsType[document.document_type].title}
                        </div>
                        <div className="collapsible-body">
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <div style={{display: "flex", justifyContent: "space-around"}}>
                                    {renderOphtalmologistSignatureInfos(document)}
                                    {renderOrthoptistSignatureInfos(document)}
                                </div>
                                {renderIframe(document.iframe)}
                                <div style={{display: "flex", gap: 20}}>
                                    <div className="input-field outlined" style={{width: "50%"}}>
                                        <input type="text"
                                               value={Helper.capitalizeFirstLetter(props.office_location.current) ?? ""}
                                               onChange={(e) => props.handleLocalizationChange(e.target.value)}
                                        />
                                        <label htmlFor="email">Lieu de signature</label>
                                    </div>
                                    <div className="red-text"
                                         style={{
                                             display: props.validateLocalization(props.office_location.current) ? "none" : "flex",
                                             alignItems: "center",
                                             gap: "0.5vw"
                                         }}>
                                        <i className="material-icons">error</i>
                                        Veuillez saisir une lieu de signature.
                                    </div>

                                    <a style={{
                                        display: props.localizationChanged() ? "flex" : "none",
                                        gap: 5
                                    }}
                                       className="btn blue darken-2 z-depth-0"
                                       onClick={props.updateOfficeLocalization}>
                                        <i className="material-icons-outlined">save</i>
                                        Enregistrer le lieu de signature
                                    </a>
                                </div>
                                {renderSignatureButton(document)}
                            </div>
                        </div>
                    </li>
                )
            })}
        </ul>
    </div>
}